import { Dispatch, SetStateAction } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import AddBank from "../../Modals/addBank";
import { isValidInput } from "../../utils/validations";
import usePermission from "../../hooks/usePermission";
import useTranslation from "../../hooks/traslation";

type Props = {
  open: boolean;
  name: string;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setName: Dispatch<SetStateAction<string>>;
  handleSubmit: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setDebouncedSearchTerm: Dispatch<SetStateAction<string>>;
  setSearchTerm: Dispatch<SetStateAction<string>>;
  searchTerm: string;
  isFormLoading?: boolean;
};

const BanksTopbar = ({
  open,
  setOpen,
  name,
  setName,
  handleSubmit,
  selectedId,
  setSelectedId,
  setDebouncedSearchTerm,
  setSearchTerm,
  searchTerm,
  isFormLoading = false,
}: Props) => {
  const { isAdd } = usePermission({
    label: "Manage Banks",
    page_permission: "isView",
  });

  const handleCloseModal = () => {
    setOpen(false);
  };

  const translate = useTranslation();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              placeholder={translate?.user?.SearchHere || "Search here..."}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: React.ChangeEvent<HTMLInputElement>) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
        </div>
        {isAdd ? (
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => {
                setName("");
                setSelectedId("");
                setOpen(true);
              }}
            >
              <AddIcon /> Add Bank
            </Button>
          </div>
        ) : null}
      </div>

      <AddBank
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        name={name}
        setName={setName}
        handleSubmit={handleSubmit}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        isFormLoading={isFormLoading}
      />
    </>
  );
};

export default BanksTopbar;
